import { graphql } from "gatsby"
import React from "react"

import Accordion from "@blocks/Accordion/Accordion"
import AuthorBox from "@blocks/AuthorBox/AuthorBox"
import BookCatalog from "@blocks/BookCatalog/BookCatalog"
import Breadcrumb from "@blocks/Breadcrumb/Breadcrumb"
import CardImageGrid from "@blocks/CardImageGrid/CardImageGrid"
import CardMinorGrid from "@blocks/CardMinorGrid/CardMinorGrid"
import CardPlainGrid from "@blocks/CardPlainGrid/CardPlainGrid"
import CarouselManual from "@blocks/CarouselManual/CarouselManual"
import Combo5050 from "@blocks/Combo5050/Combo5050"
import ComboVideo from "@blocks/ComboVideo/ComboVideo"
import ContactCard from "@blocks/ContactCard/ContactCard"
import CoreButtons from "@blocks/CoreButtons/CoreButtons"
import CoreColumns from "@blocks/CoreColumns/CoreColumns"
import CoreEmbed from "@blocks/CoreEmbed/CoreEmbed"
import CoreHeading from "@blocks/CoreHeading/CoreHeading"
import CoreImage from "@blocks/CoreImage/CoreImage"
import CoreList from "@blocks/CoreList/CoreList"
import CoreParagraph from "@blocks/CoreParagraph/CoreParagraph"
import CoreQuote from "@blocks/CoreQuote/CoreQuote"
import CoreTable from "@blocks/CoreTable/CoreTable"
import CtaBox from "@blocks/CtaBox/CtaBox"
import Form from "@blocks/Form/Form"
import FrontPageHero from "@blocks/FrontPageHero/FrontPageHero"
import GravityFormsFormWrapper from "@blocks/GravityFormsFormWrapper/GravityFormsFormWrapper"
import HeroCombo5050 from "@blocks/HeroCombo5050/HeroCombo5050"
import HeroHighlight from "@blocks/HeroHighlight/HeroHighlight"
import HeroHighlightMinor from "@blocks/HeroHighlightMinor/HeroHighlightMinor"
import ImageFullWidth from "@blocks/ImageFullWidth/ImageFullWidth"
import InfoBox from "@blocks/InfoBox/InfoBox"
import LargeNumbers from "@blocks/LargeNumbers/LargeNumbers"
import LatestPosts from "@blocks/LatestPosts/LatestPosts"
import LinkList from "@blocks/LinkList/LinkList"
import LogoGrid from "@blocks/LogoGrid/LogoGrid"
import Logos from "@blocks/Logos/Logos"
import ManualContentGrid from "@blocks/ManualContentGrid/ManualContentGrid"
import NumericList from "@blocks/NumericList/NumericList"
import PriceSlider from "@blocks/PriceSlider/PriceSlider"
import PricingTables from "@blocks/PricingTables/PricingTables"
import RSSFeed from "@blocks/RSSFeed/RSSFeed"
import RelatedContentGrid from "@blocks/RelatedContentGrid/RelatedContentGrid"
import Script from "@blocks/Script/Script"
import SideList from "@blocks/SideList/SideList"
import Testimonials from "@blocks/Testimonials/Testimonials"
import Ticker from "@blocks/Ticker/Ticker"
import VideoAdvanced from "@blocks/VideoAdvanced/VideoAdvanced"
import VideoJWPlayer from "@blocks/VideoJWPlayer/VideoJWPlayer"

const Blocks = ({ blocks, block }) => {
  if (block) {
    blocks = [block]
  }

  if (!blocks) {
    blocks = []
  }

  const notFoundStyles = {
    display: "none",
    border: "2px solid red",
    padding: "20px",
    marginBottom: "20px",
  }

  return (
    <>
      {blocks.map((block, i) => {
        let key = i.toString()
        if (block) {
          switch (block.__typename) {
            case "WpBlockAcfAccordion":
              return <Accordion key={key} {...block} />
            case "WpBlockAcfAuthorBox":
              return <AuthorBox key={key} {...block} />
            case "WpBlockAcfBookCatalog":
              return <BookCatalog key={key} {...block} />
            case "WpBlockAcfBreadcrumb":
              return <Breadcrumb key={key} {...block} />
            case "WpBlockAcfCardLogoGrid":
              return <LogoGrid key={key} {...block} />
            case "WpBlockAcfLogos":
              return <Logos key={key} {...block} />
            case "WpBlockAcfCardMinorGrid":
              return <CardMinorGrid key={key} {...block} />
            case "WpBlockAcfCardPlainGrid":
              return <CardPlainGrid key={key} {...block} />
            case "WpBlockAcfCardImageGrid":
              return <CardImageGrid key={key} {...block} />
            case "WpBlockAcfCarouselManual":
              return <CarouselManual key={key} {...block} />
            case "WpBlockAcfCombo5050":
              return <Combo5050 key={key} {...block} />
            case "WpBlockAcfComboVideo":
              return <ComboVideo key={key} {...block} />
            case "WpBlockAcfContactCards":
              return <ContactCard key={key} {...block} />
            case "WpBlockAcfCtaBox":
              return <CtaBox key={key} {...block} />
            case "WpBlockAcfForm":
              return <Form key={key} {...block} />
            case "WpBlockAcfFrontPageHero":
              return <FrontPageHero key={key} {...block} />
            case "WpBlockAcfHeroCombo5050":
              return <HeroCombo5050 key={key} {...block} />
            case "WpBlockAcfHeroHighlight":
              return <HeroHighlight key={key} {...block} />
            case "WpBlockAcfHeroHighlightMinor":
              return <HeroHighlightMinor key={key} {...block} />
            case "WpBlockAcfImageFullWidth":
              return <ImageFullWidth key={key} {...block} />
            case "WpBlockAcfInfoBox":
              return <InfoBox key={key} {...block} />
            case "WpBlockAcfLargeNumbers":
              return <LargeNumbers key={key} {...block} />
            case "WpBlockAcfLatestPosts":
              return <LatestPosts key={key} {...block} />
            case "WpBlockAcfLinkList":
              return <LinkList key={key} {...block} />
            case "WpBlockAcfManualContentGrid":
              return <ManualContentGrid key={key} {...block} />
            case "WpBlockAcfNumericList":
              return <NumericList key={key} {...block} />
            case "WpBlockAcfPriceSlider":
              return <PriceSlider key={key} {...block} />
            case "WpBlockAcfPricingTables":
              return <PricingTables key={key} {...block} />
            case "WpBlockAcfRelatedContentGrid":
              return <RelatedContentGrid key={key} {...block} />
            case "WpBlockAcfRssFeed":
              return <RSSFeed key={key} {...block} />
            case "WpBlockAcfScript":
              return <Script key={key} {...block} />
            case "WpBlockAcfSideList":
              return <SideList key={key} {...block} />
            case "WpBlockAcfTestimonials":
              return <Testimonials key={key} {...block} />
            case "WpBlockAcfTicker":
              return <Ticker key={key} {...block} />
            case "WpBlockAcfVideoAdvanced":
              return <VideoAdvanced key={key} {...block} />
            case "WpBlockAcfVideoJwPlayer":
              return <VideoJWPlayer key={key} {...block} />
            case "WpBlockCoreParagraph":
              return <CoreParagraph key={key} {...block} />
            case "WpBlockCoreList":
              return <CoreList key={key} {...block} />
            case "WpBlockCoreTable":
              return <CoreTable key={key} {...block} />
            case "WpBlockCoreImage":
              return <CoreImage key={key} {...block} />
            case "WpBlockCoreColumns":
              return <CoreColumns key={key} {...block} />
            case "WpBlockCoreHeading":
              return <CoreHeading key={key} {...block} />
            case "WpBlockCoreEmbed":
              return <CoreEmbed key={key} {...block} />
            case "WpBlockCoreQuote":
              return <CoreQuote key={key} {...block} />
            case "WpBlockCoreButtons":
              return <CoreButtons key={key} {...block} />
            case "WpBlockGravityFormsForm":
              return <GravityFormsFormWrapper key={key} {...block} />
            default:
              return (
                <div key={key} style={notFoundStyles}>
                  <code>{block.__typename}</code> not found.
                </div>
              )
          }
        }
        return null
      })}
    </>
  )
}

export default Blocks

export const query = graphql`
  fragment BlocksFirstLevel on WpBlockUnion {
    __typename
    ... on WpBlockCoreColumns {
      ...CoreColumns
    }
  }
  fragment Blocks on WpBlockUnion {
    __typename
    ... on WpBlockAcfAccordion {
      ...Accordion
    }
    ... on WpBlockAcfAuthorBox {
      ...AuthorBox
    }
    ... on WpBlockAcfBookCatalog {
      ...BookCatalog
    }
    ... on WpBlockAcfBreadcrumb {
      ...Breadcrumb
    }
    ... on WpBlockAcfLogos {
      ...Logos
    }
    ... on WpBlockAcfCardLogoGrid {
      ...LogoGrid
    }
    ... on WpBlockAcfCardMinorGrid {
      ...CardMinorGrid
    }
    ... on WpBlockAcfCardPlainGrid {
      ...CardPlainGrid
    }
    ... on WpBlockAcfCardImageGrid {
      ...CardImageGrid
    }
    ... on WpBlockAcfCarouselManual {
      ...CarouselManual
    }
    ... on WpBlockAcfCombo5050 {
      ...Combo5050
    }
    ... on WpBlockAcfComboVideo {
      ...ComboVideo
    }
    ... on WpBlockAcfContactCards {
      ...ContactCards
    }
    ... on WpBlockAcfCtaBox {
      ...CtaBox
    }
    ... on WpBlockAcfForm {
      ...Form
    }
    ... on WpBlockAcfFrontPageHero {
      ...FrontPageHero
    }
    ... on WpBlockAcfHeroCombo5050 {
      ...HeroCombo5050
    }
    ... on WpBlockAcfHeroHighlight {
      ...HeroHighlight
    }
    ... on WpBlockAcfHeroHighlightMinor {
      ...HeroHighlightMinor
    }
    ... on WpBlockAcfImageFullWidth {
      ...ImageFullWidth
    }
    ... on WpBlockAcfInfoBox {
      ...InfoBox
    }
    ... on WpBlockAcfLargeNumbers {
      ...LargeNumbers
    }
    ... on WpBlockAcfLatestPosts {
      ...LatestPosts
    }
    ... on WpBlockAcfLinkList {
      ...LinkList
    }
    ... on WpBlockAcfManualContentGrid {
      ...ManualContentGrid
    }
    ... on WpBlockAcfNumericList {
      ...NumericList
    }
    ... on WpBlockAcfPriceSlider {
      ...PriceSlider
    }
    ... on WpBlockAcfPricingTables {
      ...PricingTables
    }
    ... on WpBlockAcfRelatedContentGrid {
      ...RelatedContentGrid
    }
    ... on WpBlockAcfRssFeed {
      ...RSSFeed
    }
    ... on WpBlockAcfScript {
      ...Script
    }
    ... on WpBlockAcfSideList {
      ...SideList
    }
    ... on WpBlockAcfTestimonials {
      ...Testimonials
    }
    ... on WpBlockAcfTicker {
      ...Ticker
    }
    ... on WpBlockAcfVideoAdvanced {
      ...VideoAdvanced
    }
    ... on WpBlockAcfVideoJwPlayer {
      ...VideoJwPlayer
    }
    ... on WpBlockCoreParagraph {
      ...CoreParagraph
    }
    ... on WpBlockCoreList {
      ...CoreList
    }
    ... on WpBlockCoreTable {
      ...CoreTable
    }
    ... on WpBlockCoreImage {
      ...CoreImage
    }
    ... on WpBlockCoreHeading {
      ...CoreHeading
    }
    ... on WpBlockCoreEmbed {
      ...CoreEmbed
    }
    ... on WpBlockCoreQuote {
      ...CoreQuote
    }
    ... on WpBlockCoreButtons {
      ...CoreButtons
    }
    ... on WpBlockGravityFormsForm {
      ...GfForm
    }
  }
`
